import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { setSelectedLocation as setReduxLocation } from "../slices/profileSlice";
import { _update_profile } from "../common/axios_services";

const STORAGE_KEY = "selectedLocation";

export const useSelectedLocation = () => {
  const dispatch = useDispatch();

  const saveLocation = useCallback(
    (state, lga, shouldSyncToDB = true) => {
      if (state && lga) {
        const locationData = {
          state: typeof state === "string" ? state : state.name,
          lga: typeof lga === "string" ? lga : lga.name,
        };

        console.log("Saving location:", locationData);
        localStorage.setItem(STORAGE_KEY, JSON.stringify(locationData));
        dispatch(setReduxLocation(locationData));

        if (shouldSyncToDB) {
          syncLocationToDB(locationData).catch((err) =>
            console.error("Failed to sync location to DB:", err),
          );
        }
      }
    },
    [dispatch],
  );

  const getLocation = useCallback(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      return saved ? JSON.parse(saved) : null;
    } catch (error) {
      console.error("Error parsing saved location:", error);
      return null;
    }
  }, []);

  const clearLocation = useCallback(() => {
    localStorage.removeItem(STORAGE_KEY);
    dispatch(setReduxLocation(null));
  }, [dispatch]);

  return { saveLocation, getLocation, clearLocation };
};

const syncLocationToDB = async (locationData) => {
  try {
    await _update_profile({
      state: locationData.state,
      lga: locationData.lga,
    });
  } catch (error) {
    console.error("Error syncing location to DB:", error);
    throw error;
  }
};
